import { below } from 'common/utils/breakpoint';
const gutterWidth = 8;
const baseColDenominator = 12;

export const gridStyle = `
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 ${(gutterWidth / 2) * -1}px 0 ${(gutterWidth / 2) * -1}px;
`;

export const colStyle = `
    box-sizing: border-box;
    flex: 0 0 auto;
    flex-grow: 1;
    flex-basis: 0;
    max-width: 100%;
    min-width: 0;
    padding: 0 ${gutterWidth / 2}px 0 ${gutterWidth / 2}px;
`;

/**
 * @param {Number} 預期一排數量數量 ex: 4
 * @return {string} 每格佔的寬度 ex: 33.33%
 */
export const colCell = (number = { pc: 4, mb: 6 }) => {
    return `
        flex-basis: ${(100 / 12) * (baseColDenominator / number['pc'])}%;
        max-width: ${(100 / 12) * (baseColDenominator / number['pc'])}%;
        ${below('sm')} {
            flex-basis: ${(100 / 12) * (baseColDenominator / number['mb'])}%;
            max-width: ${(100 / 12) * (baseColDenominator / number['mb'])}%;
        }
    `;
};
